export const addressHasHistoryFactory =
  ({ server }) =>
  async (address) => {
    const history = await server.getHistoryV2(address, { index: 0, limit: 1 })
    return history.length > 0
  }
